// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"124faf93","24":"54093af0","52":"36199f12","787":"eb09adb9"}[chunkId] + ".chunk.js";
};